<template>
  <div>
    <div class="home-container">
      <list v-model="isLoading"
            :finished="dataLoadingFinished"
            loading-text=" "
            finished-text="到底了"
            @load="initItemFeed"
      >
        <MixItemListLite :dataList="dataList" @onDelete="onDeleteItem"></MixItemListLite>
      </list>
      <Empty v-if="dataLoadingFinished && !totalCount"></Empty>
    </div>
  </div>
</template>

<script>
  import {List, Empty, Toast} from "vant"
  import MixItemList from "@/components/ugc_item/MixItemList";
  import MixItemListLite from "./MixItemListLite";

  export default {
    name: "MixItemFeedLite",
    components: {
      MixItemListLite, MixItemList, List, Empty
    },
    props: {
      listType: {},
    },
    data() {
      return {
        currentPage: 0,
        maxCursor: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,

        showLogin: false,
        isLoading: false,
        dataLoadingFinished: false,

        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        // let curPage = this.$route.query.page
        // if (curPage) {
        //   this.currentPage = parseInt(curPage)
        // } else {
        this.currentPage = 0
        // }
        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
        this.showLogin = false
      },

      createToast(text, type) {
        Toast({
          message: text,
          duration: 1500,
        })
      },

      async initItemFeed() {
        this.isLoading = true
        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
        }

        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          // tab 已划走
          if (params.list_type !== this.listType) {
            return
          }

          if (result.code === 0) {

            console.log(result)
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            this.showLogin = true
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            this.createToast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          this.createToast("网络异常", "error")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },

      onChange() {
        // let params = {
        //   page: this.currentPage,
        //   list_type: this.listType,
        // }
        // this.$router.push({query: params})
        this.initParams()
        this.initItemFeed()
      },

      onLoginSuccess() {
        window.location.reload()
      },

      onDeleteItem(itemId) {
        let params = {
          item_id: itemId,
          action: "remove",
          list_type: this.listType,
        }
        this.$store.dispatch("UpdateItemList", params).then((data)=> {
          if (data.code === 0) {
            Toast("已移出列表")
          } else {
            Toast("系统错误")
          }
        }, ()=> {
          Toast("网络异常")
        })
      }
    },
    computed: {},
    watch: {
      listType() {
        this.onChange()
      },
    }
  };
</script>

<style scoped>
  .home-container {
    position: relative;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
</style>
